import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isBoolean from 'lodash/isBoolean';
import isArray from 'lodash/isArray';

import isWithinInterval from 'date-fns/isWithinInterval';

// eslint-disable-next-line consistent-return
const datesValidation = (dates, { minDate, maxDate }) => {
  if (isObject(dates)) {
    return isWithinInterval(dates.startDate, { start: minDate, end: maxDate });
  }
};

const fieldsValidations = {
  destination: (value) => isNumber(value) || isString(value),
  departure: (value) => isNumber(value),
  dates: datesValidation,
  nights: (nights) => isNumber(nights),
  adults: (value) => isNumber(value) && value > 0 && value < 5,
  flexNights: (value) => isBoolean(value),
  childrenAges: (value) =>
    isArray(value) && value.length < 4 && value.every((v) => v >= 0 && v <= 17),
  destinationQuery: (value) => isString(value),
};

const getValidParams = (params, datesRange = {}) => {
  const validParams = {};

  for (const field in params) {
    const value = params[field];
    const fieldCheck = fieldsValidations[field];
    const checkIsPassed = Boolean(fieldCheck) && fieldCheck(value, datesRange);

    if (checkIsPassed) {
      validParams[field] = value;
    }
  }

  return validParams;
};

export default getValidParams;
